import * as React from "react";
const SvgFiRrSunPlantWilt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-sun-plant-wilt_svg__a)">
      <path
        fill="#062147"
        d="M21.93 11.648C21.611 7.352 18.939 7 18.084 7c-1.823 0-3.761 1.238-4.047 4.635a3.7 3.7 0 0 0-2.119-.646c-.857 0-3.537.354-3.848 4.67a3 3 0 0 0-2.069 2.851c0 1.202.725 2.804 1.407 3.7.38.502.961.789 1.593.789s1.213-.287 1.593-.788c.683-.897 1.407-2.499 1.407-3.701a3 3 0 0 0-1.931-2.802c.109-1.379.55-2.719 1.848-2.719 1.343 0 2.083 1.251 2.083 3.521v6.489a1 1 0 1 0 2 0V12.521c0-2.271.74-3.522 2.083-3.522 1.291 0 1.734 1.327 1.846 2.698a3 3 0 0 0-1.929 2.802c0 1.206.736 2.819 1.429 3.725.377.493.949.775 1.571.775s1.194-.282 1.571-.775c.692-.905 1.429-2.519 1.429-3.725 0-1.33-.87-2.46-2.07-2.852zM9 21.001c-.462-.607-.999-1.828-.999-2.49a1 1 0 0 1 2 0c0 .662-.537 1.883-1.001 2.49m12.018-3.991c-.479-.628-1.017-1.834-1.017-2.51 0-.495.306-.978.961-.978s1.039.469 1.039.978c0 .676-.537 1.882-.983 2.51M5.334 13.1a6 6 0 0 1-.517-.529l-2.244 1.296a.998.998 0 0 1-1.366-.366 1 1 0 0 1 .366-1.366l2.248-1.298a5.5 5.5 0 0 1-.223-.836H1a1 1 0 1 1 0-2h2.589a6 6 0 0 1 .205-.81L1.552 5.916a1 1 0 1 1 .988-1.738L4.779 5.45q.294-.35.643-.646l-1.288-2.23a1 1 0 0 1 1.732-1l1.29 2.234q.221-.078.451-.135.197-.048.393-.083V1a1 1 0 1 1 2 0v2.595q.41.076.803.212l1.282-2.255a1 1 0 1 1 1.738.988l-1.28 2.253q.328.277.615.606l2.272-1.268a1 1 0 0 1 1.365.371 1 1 0 0 1-.371 1.365l-2.258 1.292c-.827.474-1.886.283-2.521-.451-.884-1.02-2.212-1.428-3.558-1.096a3.43 3.43 0 0 0-2.478 2.481c-.324 1.318.07 2.633 1.056 3.515a1 1 0 0 1-1.334 1.49z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-sun-plant-wilt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSunPlantWilt;
